module.exports = __webpack_public_path__ + "./img/0.d63dd778.png";